import React from "react";
import { ChevronDown, ChevronRight, Layers, RefreshCw, SlidersHorizontal } from "lucide-react";

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";

import { Cartao } from "./SecaoDados";
import SeletorModulos from "./SeletorModulos";

function Repeticao({ form, definir, edicao }) {
  return (
    <div className="space-y-4">
      <label className="flex items-center justify-between p-3 bg-muted rounded-lg cursor-pointer">
        <span className="flex items-center gap-2 text-sm font-medium"><RefreshCw className="w-4 h-4 text-blue-600" />Despesa recorrente</span>
        <Switch checked={form.isRecurring} disabled={edicao} data-e2e="campo-recorrente"
          onCheckedChange={(v) => { definir("isRecurring", v); if (v) definir("installments", ""); }} />
      </label>
      {form.isRecurring ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <Label>Período de recorrência</Label>
            <Select value={form.recurringPeriod} onValueChange={(v) => definir("recurringPeriod", v)} disabled={edicao}>
              <SelectTrigger className="mt-1"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="weekly">Semanal</SelectItem>
                <SelectItem value="monthly">Mensal</SelectItem>
                <SelectItem value="yearly">Anual</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label>Quantas vezes vai se repetir? *</Label>
            <Input type="number" min="1" max="60" value={form.recurringCount} onChange={(e) => definir("recurringCount", e.target.value)}
              placeholder="Ex: 12" className="mt-1" disabled={edicao} />
          </div>
        </div>
      ) : (
        <div>
          <Label>Quantidade de parcelas</Label>
          <Input type="number" min="0" value={form.installments} onChange={(e) => definir("installments", e.target.value)}
            placeholder="0 = sem parcelamento" className="mt-1" disabled={edicao} data-e2e="campo-parcelas" />
        </div>
      )}
      {edicao && <p className="text-xs text-muted-foreground">Recorrência e parcelas só podem ser definidas ao criar a despesa.</p>}
    </div>
  );
}

// "Avançado": repetição/parcelas, MÓDULOS (novo em 21/09/2026) e observações.
export default function SecaoAvancado({ d, aberto, setAberto }) {
  const { form, definir } = d;
  const Seta = aberto ? ChevronDown : ChevronRight;
  const resumoFechado = form.modulos.length ? `${form.modulos.length} módulo(s) marcado(s)` : "Recorrência, parcelas, módulos e observações";
  return (
    <Cartao titulo="Avançado" icone={SlidersHorizontal} e2e="secao-avancado"
      acao={
        <button type="button" onClick={() => setAberto(!aberto)} data-e2e="abrir-avancado"
          className="flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground">
          {!aberto && <span className="hidden sm:inline">{resumoFechado}</span>}<Seta className="w-4 h-4" />
        </button>
      }>
      {aberto && (
        <div className="space-y-6">
          <Repeticao form={form} definir={definir} edicao={!!d.original} />
          <div>
            <div className="flex items-center gap-2 mb-1"><Layers className="w-4 h-4 text-primary" /><Label className="text-sm">Atribuir aos módulos</Label></div>
            <p className="text-xs text-muted-foreground mb-3">
              Marque os módulos que usam essa despesa. Ela entra no lucro deles no Relatório de Módulos — dividida em partes
              iguais se marcar mais de um. Sem marcar nenhum, fica como despesa comum da loja.
            </p>
            <SeletorModulos valor={form.modulos} onChange={(v) => definir("modulos", v)} />
          </div>
          <div>
            <Label>Observações</Label>
            <Textarea value={form.notes} onChange={(e) => definir("notes", e.target.value)} placeholder="Notas adicionais..." className="mt-1" rows={3} />
          </div>
        </div>
      )}
    </Cartao>
  );
}
